export default __webpack_public_path__ + "static/media/transplants.32ac3ffa.svg";